import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import InputNumber from 'rc-input-number';
import type { InputNumberProps as RcInputNumberProps } from 'rc-input-number';
import type { FC } from 'react';
import './index.less';

const classPrefix = 'beukay-input-numeric';

type ValueType = string | number;

export interface InputNumberProps<T extends ValueType = ValueType>
  extends Omit<RcInputNumberProps<T>, 'width' | 'size'> {
  size?: 'sm' | 'md' | 'lg';
  width?: string | number;
}

const InputNumeric: FC<InputNumberProps> = (p) => {
  const { size = 'md', width, ...otherProps } = p;

  const selfStyle = { width };

  const upHandler = (
    <div className={`${classPrefix}-increase`}>
      <PlusOutlined />
    </div>
  );

  const downHandler = (
    <div className={`${classPrefix}-decrease`}>
      <MinusOutlined />
    </div>
  );

  return (
    <InputNumber
      {...otherProps}
      prefixCls={classPrefix}
      className={`${classPrefix}-${size}`}
      style={selfStyle}
      upHandler={upHandler}
      downHandler={downHandler}
    />
  );
};

export default InputNumeric;
